import React from "react";
import { IconCheck, IconX } from "@tabler/icons-react";
import { Box, Group } from "@mantine/core";

export interface BannerExampleProps {
  children: React.ReactNode;
}

export const BannerExample = ({ children }: BannerExampleProps) => {
  return (
    <Box
      p="md"
      style={{
        borderRadius: "5px",
        backgroundColor: "#eeebea",
        fontWeight: 600,
        fontSize: "16px",
      }}
    >
      <Box style={{ color: "#1F47D3", width: "100%" }}>{children}</Box>
      <Group mt="xs" gap="xs" style={{ width: "100%" }}>
        <Box
          style={{
            backgroundColor: "white",
            borderRadius: "5px",
            flex: 1,
            display: "flex",
            padding: "15px",
          }}
        >
          <Group
            gap="xs"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <Box
              style={{
                backgroundColor: "#9F9E9D",
                width: "80%",
                height: "20px",
                borderRadius: "5px",
              }}
            />
            <IconCheck
              size={20}
              color="white"
              strokeWidth={3}
              style={{ backgroundColor: "#38b84f", borderRadius: "5px" }}
            />
          </Group>
        </Box>
        <Box
          style={{
            backgroundColor: "#1F47D3",
            borderRadius: "5px",
            flex: 1,
            display: "flex",
            padding: "15px",
          }}
        >
          <Group
            gap="xs"
            style={{ width: "100%", justifyContent: "space-between" }}
          >
            <Box
              style={{
                backgroundColor: "white",
                width: "80%",
                height: "20px",
                borderRadius: "5px",
              }}
            />
            <IconX size={20} strokeWidth={4} color="#f40003" />
          </Group>
        </Box>
      </Group>
    </Box>
  );
};
